import css from 'styled-jsx/css';

const styles = css.global`html {
  scroll-behavior: smooth;
  scroll-padding-top: 58px;
}

#santander-menu {
  position: fixed;
  z-index: 9998;
  top: 80px;
  left: 0;
  width: 100%;
}

#santander-menu,
#santander-menu amp-mega-menu > nav,
#santander-menu .mega-menu-ampless > nav {
  background: none;
  background-color: #cc0000;
}

#santander-menu amp-mega-menu ul,
#santander-menu .mega-menu-ampless ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

#santander-menu amp-mega-menu > nav,
#santander-menu amp-mega-menu ul,
#santander-menu amp-mega-menu ul > li,
#santander-menu .mega-menu-ampless > nav,
#santander-menu .mega-menu-ampless ul,
#santander-menu .mega-menu-ampless ul > li {
  height: 100%;
}

#santander-menu amp-mega-menu ul > li,
#santander-menu .mega-menu-ampless ul > li {
  height: 100%;
  margin-right: 48px;
}

#santander-menu amp-mega-menu ul > li > span,
#santander-menu amp-mega-menu ul > li > a,
#santander-menu .mega-menu-ampless ul > li > span,
#santander-menu .mega-menu-ampless ul > li > a {
  color: #fff;
  font-size: 18px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* importante não colocar divs exatamente dentro do amp-mega-menu para poder esconder a mask */
#santander-menu > amp-mega-menu > div,
#santander-menu > .mega-menu-ampless > div {
  visibility: hidden;
  display: none;
}

#santander-menu .menu-content {
  border: 1px solid #979797;
  padding: 32px 0;
}

#santander-menu .menu-col {
  min-width: 321px;
}

#santander-menu .menu-col > h2 {
  margin: 0;
  color: #222222;
  font-family: 'Open Sans';
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 16px;
  margin-bottom: calc(28px - 16px);
}

#santander-menu .menu-col > div {
  border-bottom: 1px solid #cccccc;
  padding: 16px 0;
}

#santander-menu .menu-col p,
#santander-menu .menu-col a {
  margin: 0;
  margin-left: 16px;
  cursor: pointer;
  color: #222222;
  font-size: 16px;
}

#santander-menu .menu-content .content-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

#santander-menu .menu-col:nth-child(2) {
  margin: 0 56px;
}

#santander-menu .no-border {
  border: none;
}

#santander-menu a {
  text-decoration: none;
}

#santander-menu amp-mega-menu,
#santander-menu .mega-menu-ampless {
  display: none;
}

#santander-menu .mega-menu-ampless {
  height: 60px;
  display: none;
  font-family: 'Open Sans';
}

#santander-menu .mega-menu-ampless ul {
  list-style-type: none;
}

#santander-menu .mega-menu-ampless nav,
#santander-menu .mega-menu-ampless ul,
#santander-menu .mega-menu-ampless li,
#santander-menu .mega-menu-ampless span {
  height: 100%;
}

#santander-menu .mega-menu-ampless span {
  cursor: pointer;
}

#santander-menu .mega-menu-ampless ul li > div.closed {
  display: none;
  background-color: #fff;
}

#santander-menu .mega-menu-ampless ul li > div.opened {
  position: absolute;
  width: 100%;
  left: 0;
  background-color: #fff;
}

.dismiss-menu {
  display: none;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

@media (min-width: 992px) {
  html {
    scroll-padding-top: 140px;
  }
  #santander-menu amp-mega-menu,
  #santander-menu .mega-menu-ampless {
    display: block;
  }

  .dismiss-menu {
    display: flex;
    z-index: 10;
  }
}
`;

export default styles;